export const distance = (x1: number, y1: number, x2: number, y2: number): number => {
  const a = x1 - x2;
  const b = y1 - y2;

  return Math.hypot(a, b);
};

export function bezier(t: number, initial: number, p1: number, p2: number, final: number): number {
  return (
    (1 - t) * (1 - t) * (1 - t) * initial +
    3 * (1 - t) * (1 - t) * t * p1 +
    3 * (1 - t) * t * t * p2 +
    t * t * t * final
  );
}

export function reMap(
  value: number,
  lowIn: number,
  highIn: number,
  lowOut: number,
  highOut: number,
): number {
  return lowOut + ((highOut - lowOut) * (value - lowIn)) / (highIn - lowIn);
}

export function easeIn(
  value: number,
  lowIn: number,
  highIn: number,
  lowOut: number,
  highOut: number,
): number {
  // Using quadratic ease-in function
  const t = (value - lowIn) / (highIn - lowIn);
  const easedT = t * t;

  return lowOut + easedT * (highOut - lowOut);
}
